// fleet-generated: do not edit by hand
//
// Rendered from    : infra/fleet/artifacts/ui-core/page-container.tmpl.tsx
// Parameters       : infra/fleet/registry/repos.ts  (entry "tendly-app")
// Destination      : packages/fleet/ui/src/page-container.tsx
//
// TO CHANGE THIS FILE, edit the template or the registry entry in infra and
// re-render. Editing it here is reverted by the next render, and the guard
// in this repo goes red in the meantime:
//
//     cd ../infra && node fleet/fleet.ts render --repo tendly-app
//     node fleet/fleet.ts check --repo tendly-app
//
// The generator runs LOCALLY and is never invoked by CI. CI only verifies
// that what is committed matches the hash in .github/fleet-lock.json, which
// also records WHICH infra commit produced it. The commit is deliberately
// not repeated here: one value, one place — and stamping it into every file
// meant a one-line template edit rewrote four files in 28 repos.
import type { JSX } from "solid-js";
import { cn } from "@tendly/shared";

interface PageContainerProps {
  children: JSX.Element;
  class?: string;
  containerClass?: string;
  /**
   * Strictly typed max-width class.
   * If a new size is needed (e.g. "md", "xl"), add it to this union type
   * and include its corresponding CSS class in the switch statement below.
   */
  maxWidth?: "lg" | "2xl" | "3xl" | "4xl" | "5xl" | "6xl" | "7xl" | "full";
}

export function PageContainer(props: PageContainerProps) {
  const maxWidthClass = () => {
    switch (props.maxWidth) {
      case "lg": {
        return "max-w-lg";
      }
      case "2xl": {
        return "max-w-2xl";
      }
      case "3xl": {
        return "max-w-3xl";
      }
      case "4xl": {
        return "max-w-4xl";
      }
      case "5xl": {
        return "max-w-5xl";
      }
      case "6xl": {
        return "max-w-6xl";
      }
      case "7xl": {
        return "max-w-7xl";
      }
      case "full": {
        return "max-w-full";
      }
      case undefined: {
        return "max-w-6xl";
      }
    }
    return "max-w-6xl";
  };

  return (
    <div class={cn("flex-1 overflow-y-auto p-6 md:p-10 select-none", props.containerClass)}>
      <div class={cn("mx-auto w-full", maxWidthClass(), props.class)}>{props.children}</div>
    </div>
  );
}
